export default __webpack_public_path__ + "static/media/usuario.f970755c.svg";